module.exports = __webpack_public_path__ + "static/media/bunny_4.ca0e218c.jpg";